import type { Transaction } from '../types';

const toNumber = (value: unknown): number => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
};

const toIsoString = (value: unknown): string | undefined => {
    if (!value) return undefined;
    if (typeof value === 'string') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
    }
    if (typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
    }
    if (typeof value === 'object' && value !== null && 'toDate' in value && typeof (value as { toDate?: unknown }).toDate === 'function') {
        const date = (value as { toDate: () => Date }).toDate();
        return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
    }
    return undefined;
};

const sourceLabelForSnapshot = (holding: Record<string, unknown>) => {
    const source = String(holding.source || '').trim().toLowerCase();
    if (source === 'manual') return 'Added manually';
    if (source === 'csv') return 'Imported from CSV';
    return 'Imported snapshot';
};

export const buildSyntheticHoldingBuyTransaction = (
    holdingDocId: string,
    holding: Record<string, unknown>,
    lastImportAt: string,
    snapshotAsOf: string | undefined,
    data: Record<string, unknown>
): Transaction => {
    const baseCurrency = String(data.baseCurrency || 'USD');
    const createdAt = toIsoString(holding.createdAt) || toIsoString(data.createdAt || data.created);
    const transactionDate = createdAt || lastImportAt;
    const holdingCostCurrency = String(holding.costCurrency || '').trim().toUpperCase();
    const holdingQuoteCurrency = String(holding.currency || '').trim().toUpperCase();

    return {
        id: `holding_${holdingDocId}`,
        action: 'Buy',
        symbol: String(holding.displaySymbol || holding.symbol || ''),
        displaySymbol: String(holding.displaySymbol || holding.symbol || ''),
        name: String(holding.name || holding.displaySymbol || holding.symbol || 'Unknown'),
        date: transactionDate,
        createdAt,
        quantity: toNumber(holding.quantity),
        price: toNumber(holding.avgCost),
        priceCurrency: holdingCostCurrency || holdingQuoteCurrency || baseCurrency,
        amount: toNumber(holding.costBasis),
        currency: holdingCostCurrency || holdingQuoteCurrency || baseCurrency,
        source: 'snapshot',
        sourceLabel: sourceLabelForSnapshot(holding),
        isSynthetic: true,
        snapshotAsOf,
        instrumentId: typeof holding.instrumentId === 'string' ? holding.instrumentId : undefined,
        exchange: typeof holding.exchange === 'string' ? holding.exchange : undefined,
    } as Transaction;
};
